import { useContext } from 'react';
import { find } from 'lodash';

import { SliceContext } from './context';

const getInfo = async (
  data, {
    fetch,
    organizations,
    divisions,
    markets,
    specialties,
    subSpecialties,
  },
) => {
  const info = {
    type: 'system',
    label: 'system',
    sort: 1,
  };

  if (data.attributes.divisionUid) {
    info.type = 'division';
    info.sort = 6;

    let division;
    let organization;

    if (organizations.length && divisions.length) {
      division = find(divisions, ['id', data.attributes.divisionUid]);
      organization = find(organizations, ['id', data.attributes.orgUid]);
    } else {
      division = await fetch('division', { id: data.attributes.divisionUid }).then(({ data: { data: r } }) => r);
      organization = await fetch('organization', { id: data.attributes.orgUid }).then(({ data: { data: r } }) => r);
    }

    info.label = division && division.label;
    info.lineage = [
      division && division.label,
      organization && organization.label,
    ];
  } else if (data.attributes.orgUid) {
    info.type = 'org';
    info.sort = 5;

    let organization;

    if (organizations.length) {
      organization = find(organizations, ['id', data.attributes.orgUid]);
    } else {
      organization = await fetch('organization', { id: data.attributes.orgUid }).then(({ data: { data: r } }) => r);
    }

    info.label = organization && organization.label;
    info.lineage = [
      organization && organization.label,
    ];
  } else if (data.attributes.subSpecialtyUid) {
    info.type = 'sub-specialty';
    info.sort = 4;

    let subSpecialty;
    let specialty;
    let market;

    if (markets.length && specialties.length && subSpecialties.length) {
      subSpecialty = find(subSpecialties, ['id', data.attributes.subSpecialtyUid]);
      specialty = find(specialties, ['id', data.attributes.specialtyUid]);
      market = find(markets, ['id', data.attributes.marketUid]);
    } else {
      subSpecialty = await fetch('sub-specialty', { id: data.attributes.subSpecialtyUid }).then(({ data: { data: r } }) => r);
      specialty = await fetch('specialty', { id: data.attributes.specialtyUid }).then(({ data: { data: r } }) => r);
      market = await fetch('market', { id: data.attributes.marketUid }).then(({ data: { data: r } }) => r);
    }

    info.label = subSpecialty && subSpecialty.label;
    info.lineage = [
      subSpecialty && subSpecialty.label,
      specialty && specialty.label,
      market && market.label,
    ];
  } else if (data.attributes.specialtyUid) {
    info.type = 'specialty';
    info.sort = 3;

    let specialty;
    let market;

    if (markets.length && specialties.length) {
      specialty = find(specialties, ['id', data.attributes.specialtyUid]);
      market = find(markets, ['id', data.attributes.marketUid]);
    } else {
      specialty = await fetch('specialty', { id: data.attributes.specialtyUid }).then(({ data: { data: r } }) => r);
      market = await fetch('market', { id: data.attributes.marketUid }).then(({ data: { data: r } }) => r);
    }

    info.label = specialty && specialty.label;
    info.lineage = [
      specialty && specialty.label,
      market && market.label,
    ];
  } else if (data.attributes.marketUid) {
    info.type = 'market';
    info.sort = 2;

    let market;

    if (markets.length) {
      market = find(markets, ['id', data.attributes.marketUid]);
    } else {
      market = await fetch('market', { id: data.attributes.marketUid }).then(({ data: { data: r } }) => r);
    }

    info.label = market && market.label;
    info.lineage = [
      market && market.label,
    ];
  }

  return info;
};

const serialize = values => ({
  $slice_id: (values.division && values.division.id) ||
    (values.subSpecialty && values.subSpecialty.id) ||
    (values.org && values.org.id) ||
    (values.specialty && values.specialty.id) ||
    (values.market && values.market.id),
  $slice_type: (values.subSpecialty && values.subSpecialty.id && 'subSpecialty') ||
    (values.division && values.division.id && 'division') ||
    (values.org && values.org.id && 'org') ||
    (values.specialty && values.specialty.id && 'specialty') ||
    (values.market && values.market.id && 'market') ||
    'system',
});

const useSlice = () => {
  const slice = useContext(SliceContext);

  return {
    ...slice,

    getInfo: p => getInfo(p, slice),

    serialize: p => serialize(p),
  };
};

export default useSlice;
export {
  serialize,
};
